import { CircularProgress, styled } from '@mui/material';
import { COLORS } from '../../../theme/color';
import { breakpoints } from '../../../theme/theme';

interface AddressCONProps {
  $isDefault?: boolean;
}

export const AddressCON = styled('div')<AddressCONProps>`
  width: 100%;
  min-height: 120px;
  background-color: ${props => (props.$isDefault ? COLORS.SecBlue : '#ffffff')};
  border: 1px solid ${props => (props.$isDefault ? COLORS.MainBlue : '#e9e5e5')};
  border-radius: 10px;
  padding: 10px 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: ${COLORS.SecBlack};
  transition: all 0.2s ease-in-out;
  position: relative;
  background: ${props =>
    props.$isDefault ? `linear-gradient(135deg, ${COLORS.SecBlue}40 0%, #ffffff 100%)` : '#ffffff'};

  &:hover {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-color: ${COLORS.MainBlue};
    transform: translateY(-2px);
  }

  .card-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
  }

  .address {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 12px;
    color: ${COLORS.MainBlack};
  }

  .location {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    color: ${COLORS.SecBlack};

    .address-code {
      font-size: 12px;
      color: ${COLORS.MainBlue};
      background: ${COLORS.SecBlue};
      padding: 2px 8px;
      border-radius: 4px;
    }
  }

  .phone {
    color: ${COLORS.SecBlack};
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 8px;

    &:before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      background: ${COLORS.MainBlue};
      border-radius: 50%;
    }
  }

  .default {
    background: ${COLORS.MainBlue};
    border-radius: 4px;
    font-size: 12px;
    line-height: 20px;
    color: white;
    padding: 2px 12px;
  }

  @media (max-width: ${breakpoints.sm}px) {
    padding: 16px;

    .address {
      font-size: 14px;
    }
  }
`;

export const DropCON = styled('div')`
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  div {
    padding: 16px 30px 16px 20px;
    display: flex;
    align-items: center;
    flex: 1;
    border-bottom: 1px solid #e6e6e6;
    cursor: pointer;
    &:last-of-type {
      border-bottom: none;
    }
    &:hover {
      color: ${COLORS.MainBlue};
    }
  }
`;

export const AddressModalCon = styled('form')`
  h3 {
    font-weight: 700;
    font-size: 24px;
    margin: 0 0 11px 0;
  }
  label {
    font-weight: 700;
    font-size: 14px;
    display: inline-block;
    margin: 24px 0 8px 0;
  }
  .name-div {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  input::placeholder {
    font-size: 14px;
  }
  button {
    margin: 26px 0 8px 0;
  }
`;

export const AddressCon = styled('div')`
  width: 300px;
  background: #fff;
  box-shadow: 0px 2px 16px rgba(189, 189, 189, 0.25);
  border-radius: 6px;
  padding: 16px 16px 16px;
  .heading {
    font-weight: 600;
    font-size: 15px;
    line-height: 27px;
    color: #180101;
  }

  input {
    height: 40px;
    border-radius: 4px;
    border: 1px solid #e9e5e5;
    padding: 0 10px;
    font-size: 14px;
  }
`;

export const DropListCON = styled('div')`
  width: 100%;
  margin-top: 16px;
  font-family: 'Euclid Circular A', 'Outfit';

  .list-con {
    max-height: 130px;
    overflow-y: scroll;
    border: 1px solid #e9e5e5;
    border-radius: 4px;
  }

  .list {
    width: 100%;
    padding: 12px 16px;
    border-bottom: 1px solid #f5f5f5;
    transition: all 0.2s ease-in-out;

    &:hover {
      background-color: #f8f9ff;
      border-left: 3px solid ${COLORS.MainBlue};
      padding-left: 13px;
    }
    cursor: pointer;
    transition: background-color 150ms ease;
  }
  .list[data-current='true'] {
    background-color: #f8f9ff;
    border-left: 3px solid ${COLORS.MainBlue};
    padding-left: 13px;
  }
  .desc {
    font-size: 10px;
    line-height: 16px;
    color: ${COLORS.SecBlack};
  }
  .name {
    font-size: 13px;
    line-height: 24px;
    font-weight: 500;
  }
  .loading {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: ${COLORS.SecBlack};
  }
`;

export const Spinner = styled(CircularProgress)({
  color: COLORS.MainGray
});
